import orderSerializer from '../orders/serializer.js';
import packageSerializer from '../packages/serializer.js';
import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import Commons from '@features/shared/libraries/commons';

// Track order/package by code
bus.on(constants.EVENTS.TRACKING.BY_CODE, async (data) => {
  const { type, code } = data; // type: 'order' | 'package'
  const store = getStore('tracking');

  if (!type || !code) {
    store.state.error = 'Code de tracking requis';
    bus.emit(constants.EVENTS.TRACKING.ERROR, store.state.error);
    return;
  }

  // Update type and code in store
  store.setTrackingType(type);
  store.setTrackingCode(code);

  store.state.loading = true;
  store.state.error = null;
  store.state.data = null;

  try {
    let url = '';
    if (type === 'order') {
      url = constants.ENDPOINTS.TRACKING.ORDER.replace(':code', code);
    } else {
      url = constants.ENDPOINTS.TRACKING.PACKAGE.replace(':code', code);
    }

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `track-${type}-${code}`,
      url,
      method: 'GET'
    });

    const responseHandler = async (res) => {
      if (res.id === `track-${type}-${code}`) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);

        store.state.loading = false;

        if (res.success) {
          let rawData = res.data?.data || res.data;
          
          if (type === 'order') {
            try {
              
              rawData = orderSerializer.deserializeOrder(rawData);
            } catch (importErr) {
              console.error('Error deserializing order:', importErr);
            }
          } else if (type === 'package') {
            try {
              
              rawData = packageSerializer.deserializePackage(rawData);
            } catch (importErr) {
              console.error('Error deserializing package:', importErr);
            }
          }

          store.state.data = rawData;
          bus.emit(
            constants.EVENTS.TRACKING.LOADED,
            rawData
          );
        } else {
          store.state.error =
            res.message || 'Aucune information trouvée pour ce code';
          bus.emit(constants.EVENTS.TRACKING.ERROR, store.state.error);
        }
      }
    };

    bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
  } catch (error) {
    store.state.loading = false;
    store.state.error = error.message;
    bus.emit(constants.EVENTS.TRACKING.ERROR, error.message);
  }
});

// Generate share link
bus.on(constants.EVENTS.TRACKING.GENERATE_LINK, (data) => {
  const { type, code } = data;
  const baseUrl = type === 'order' 
    ? (constants.URLS?.orderTrackingBaseUrl || window.location.origin) 
    : (constants.URLS?.packageTrackingBaseUrl || window.location.origin);
  const link = `${baseUrl}/track/${type}/${code}`;

  bus.emit(constants.EVENTS.TRACKING.LINK_GENERATED, link);
});

// Copy tracking link to clipboard
bus.on(constants.EVENTS.TRACKING.COPY_LINK, async (data) => {
  const { type, code } = data;
  const baseUrl = type === 'order' 
    ? (constants.URLS?.orderTrackingBaseUrl || window.location.origin) 
    : (constants.URLS?.packageTrackingBaseUrl || window.location.origin);
  const link = `${baseUrl}/track/${type}/${code}`;

  Commons.copyToClipboard(
    link,
    () => {
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        type: 'success',
        title: 'Lien copié',
        body: 'Le lien de tracking a été copié dans le presse-papier'
      });
      bus.emit(constants.EVENTS.TRACKING.LINK_COPIED, link);
    },
    (error) => {
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        type: 'error',
        title: 'Lien non copié',
        body: "Le lien de tracking n'a pas été copié dans le presse-papier"
      });
    }
  );
});

// Copy tracking code to clipboard
bus.on(constants.EVENTS.TRACKING.COPY_CODE, async (code) => {
  Commons.copyToClipboard(
    code,
    () => {
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        type: 'success',
        title: 'Code copié',
        body: 'Le code de tracking a été copié dans le presse-papier'
      });
      bus.emit(constants.EVENTS.TRACKING.CODE_COPIED, code);
    },
    (error) => {
      bus.emit(constants.EVENTS.TOAST_NOTIFICATION.SHOW, {
        type: 'error',
        title: 'Code non copié',
        body: "Le code de tracking n'a pas été copié dans le presse-papier"
      });
    }
  );
});
